import {
  AppRootElementBlueprint,
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { ProfileSectionBlueprint } from '@platform/plugin-platform-react';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { keycloakAdminPermission } from '@platform/plugin-keycloak-admin-common';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import { KeycloakSessionSignOut } from './KeycloakSessionSignOut';
import { rootRouteRef } from './routes';

/**
 * L'administration des utilisateurs et groupes Keycloak, extraite de
 * `legacyRoot.tsx` (phase 4c).
 *
 * Titre et icône de l'entrée de menu REPRIS DE `navSections.ts` : elle
 * s'appelle « Utilisateurs », pas « Administration Keycloak » — c'est le
 * titre de la page, pas celui du menu.
 *
 * Changement visible assumé (décision 9 de la spec) : l'entrée n'est plus
 * masquée aux utilisateurs sans `keycloakAdminPermission`. Ils la voient dans
 * « Gouvernance », et la page leur refuse l'accès.
 */
const keycloakAdminPage = PageBlueprint.make({
  params: {
    path: '/admin/keycloak',
    routeRef: rootRouteRef,
    title: 'Utilisateurs',
    icon: <SupervisorAccountIcon />,
    noHeader: true,
    loader: () =>
      import('./components/KeycloakAdminPage').then(m => (
        <RequirePermission permission={keycloakAdminPermission}>
          <m.KeycloakAdminPage />
        </RequirePermission>
      )),
  },
});

/**
 * Le changement de mot de passe de « Mon profil » : la page est au socle, la
 * section est ici, avec l'appel à notre backend.
 */
const passwordSection = ProfileSectionBlueprint.make({
  name: 'password',
  params: {
    loader: () =>
      import('./KeycloakPasswordSection').then(m => <m.KeycloakPasswordSection />),
  },
});

/** Ferme la session Keycloak avant la déconnexion (crochet du socle). */
const sessionSignOut = AppRootElementBlueprint.make({
  name: 'session-sign-out',
  params: { element: <KeycloakSessionSignOut /> },
});

export default createFrontendPlugin({
  pluginId: 'keycloak-admin',
  extensions: [keycloakAdminPage, passwordSection, sessionSignOut],
});
